export const PLAN_NAME = {
  NO_PLAN: 'no plan',
  FREE: 'free',
  TEAM: 'team',
  BUSINESS: 'business',
}
